function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "3.192,120.755 7.929,115.688 11.967,92.416 42.34,77.914 40.631,67.124 61.204,28.33 72.674,32.72  78.755,25.976 88.524,22.59 90.892,11.474 95.622,9.112 106.063,17.541 130.695,22.59 134.737,19.902 134.737,2.365 141.825,0  148.239,5.74 145.867,17.541 155.657,29.344 163.404,24.285 167.454,24.958 166.78,31.706 177.91,36.776 170.492,52.956  170.492,67.124 164.422,67.124 156.323,62.058 149.25,73.875 137.775,77.247 138.779,81.286 149.25,77.914 140.471,96.458  141.825,120.067 156.323,115.688 188.036,85.672 196.809,103.878 180.949,117.373 176.893,126.818 169.151,125.802 163.404,129.177  176.893,139.296 177.91,147.058 174.535,151.107 174.535,159.535 164.422,178.757 166.78,188.869 142.843,200 136.436,198.322  133.046,200 125.305,197.312 118.891,174.701 101.358,173.69 95.622,178.757 90.892,178.076 93.247,166.272 84.478,156.16  71.664,161.894 67.632,171.325 52.473,171.325 42.34,137.612 34.224,140.313 18.388,135.247 "
});

var Svg13 = function Svg13(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HGO",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg13, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/13.e79342de.svg";
export { ForwardRef as ReactComponent };